/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { commonConstants } from '../constants';

function loader(state = false, action) {
  switch (action.type) {
    case commonConstants.SHOW_LOADER:
      return true;
    case commonConstants.HIDE_LOADER:
      return false;
    default:
      return state;
  }
}

export default loader;
